export const LOGO_MAX_HEIGHT = 51;

export const NOTIFICATIONS_LIST_MAX_HEIGHT = 340;
export const NOTIFICATIONS_LIST_MAX_WIDTH = 400;
export const NOTIFICATIONS_ICON_SIZE = 24;
export const NOTIFICATIONS_POPOVER_SCREEN_PADDING = 8;
